import React, {Component} from 'react';
import {API_ROOT} from '../../../baseUrls';
import {withStyles} from '@material-ui/core/styles';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {
  Box,
  // TextField,
  // Grid,
  Typography,
  Card,
  CardContent,
  // Button,
} from '@material-ui/core';
import ContentArea from '../../organisms/content-area/ContentArea';
import Password from './Password';
import Email from './Email';
import ReceiveEmail from './ReceiveEmail';
import MindfileVisibility from './MindfileVisibility';
import MultiUser from './MultiUser';
import Designees from './Designees';
import DeleteMindfile from './DeleteMindfile';
import Profile from './Profile';
import CloseAccount from './CloseAccount';
import { closeAccount } from '../../../state/actions/authActions';

const styles = theme => ({
  fieldWrapper: {
    marginBottom: 16,
  },
  buttonWrapper: {
    marginTop: 24,
  },
  acctSettings: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      marginRight: 8,
    },
    marginRight: -8,
    marginLeft: -8,
  },
  settingBox: {
    flex: 1,
    width: '50%',
    minWidth: 300,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      width: '100%',
    },
    marginRight: 8,
    marginLeft: 8,
  },
  card: {
    overflow: 'auto',
  }
})

class AccountSettings extends Component {
  constructor(props) {
    super(props)

    this.state = {
      newMindfileName: '',
      newMindfileNameFocus: false,
      newBirthday: '',
      newBirthdayFocus: false,
      designee1: '',
      designee1Focus: false,
      relationship1: '',
      relationship1Focus: false,
      designee2: '',
      designee2Focus: false,
      relationship2: '',
      relationship2Focus: false,
      designee3: '',
      designee3Focus: false,
      relationship3: '',
      relationship3Focus: false,
      doNotDisclose: null,
      showDesigneesSuccessMessage: false,
    }
  }

  deleteMindfile() {
    const formData = new FormData()
    // formData.append('authenticity_token', this.props.user.authenticity_token)
    formData.append('_method', 'delete')

    fetch(`${ API_ROOT }/mindfiles/${ this.props.mindfile.id }`, {
      method: 'POST',
      credentials: 'include',
      body: formData,
      headers: {'X-CSRF-Token': this.props.user.authenticity_token},
    })
    .then(resp => (resp.text()))
    .then(data => {
    })
    .catch(error => console.error(error))
    .finally(() => window.location.reload())
  }

  updateDesignees() {
    const formData = new FormData()
    formData.append("user[designee1]", this.state.designee1)
    formData.append("user[relationship1]", this.state.relationship1)
    formData.append("user[designee2]", this.state.designee2)
    formData.append("user[relationship2]", this.state.relationship2)
    formData.append("user[designee3]", this.state.designee3)
    formData.append("user[relationship3]", this.state.relationship3)
    formData.append("user[do_not_disclose]", ((this.state.doNotDisclose === 'no') ? true : false))
    // formData.append("authenticity_token", this.props.user.authenticity_token)

    fetch(`${ API_ROOT }/users/${ this.props.user.uid }/update`, {
      method: 'POST',
      credentials: 'include',
      body: formData,
      headers: {'X-CSRF-Token': this.props.user.authenticity_token},
    })
    .then(resp => (resp.json()))
    .then(data => {
      if (data.status === 'ok') {
        this.setState({ showDesigneesSuccessMessage: true })
      }
    })
    .catch(error => console.error(error))
  }

  render() {
    const { classes } = this.props
    return (
      <ContentArea>
        <Typography className={classes.cardTitle} variant="h5" gutterBottom>
          Account settings
        </Typography>

        <div className={ classes.acctSettings }>
        <Box className={ classes.settingBox } mt={2}>
          <Card className={ classes.card }>
            <CardContent>
              <Password />
            </CardContent>
          </Card>
        </Box>

        <Box className={ classes.settingBox } mt={2}>
          <Card className={ classes.card }>
            <CardContent>
              <Email />
            </CardContent>
          </Card>
        </Box>

        <Box className={ classes.settingBox } mt={2}>
          <Card className={ classes.card }>
            <CardContent>
              <ReceiveEmail />
            </CardContent>
          </Card>
        </Box>

        <Box className={ classes.settingBox } mt={2}>
          <Card className={ classes.card }>
            <CardContent>
              <MindfileVisibility />
            </CardContent>
          </Card>
        </Box>

        <Box className={ classes.settingBox } mt={2}>
          <Card className={ classes.card }>
            <CardContent>
              <MultiUser />
            </CardContent>
          </Card>
        </Box>

        <Box className={ classes.settingBox } mt={2} mb={2}>
          <Card className={ classes.card }>
            <CardContent>
              <Designees />
            </CardContent>
          </Card>
        </Box>

        </div>

        <Profile />

        { !this.props.mindfile.default ?
        <Card className={ classes.card } style={{ marginBottom: 24 }}>
          <CardContent>
            <DeleteMindfile deleteMindfile={ this.deleteMindfile.bind(this) } />
          </CardContent>
        </Card>
        : null}

        <Card className={ classes.card } style={{ marginBottom: 24 }}>
          <CardContent>
            <CloseAccount closeAccount={ this.props.closeAccount } />
          </CardContent>
        </Card>

      </ContentArea>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.auth,
    mindfile: state.mindfile,
  }
}

const mapDispatchToProps = {
  closeAccount,
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withRouter(AccountSettings)))
